/**
 * Generates a CSV string from headers and rows, then triggers a browser download.
 *
 * @param {string[]} headers - Column headers
 * @param {Array<Array<string>>} rows - 2D array of row values
 * @param {string} filename - Download filename (should end with .csv)
 */
export const downloadCsv = (headers, rows, filename) => {
  const escape = (value) => {
    let str = value == null ? "" : String(value);
    if (/^[=+\-@]/.test(str)) {
      str = "'" + str;
    }
    if (str.includes(",") || str.includes('"') || str.includes("\n")) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const csvContent = [
    headers.map(escape).join(","),
    ...rows.map((row) => row.map(escape).join(",")),
  ].join("\n");

  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
